/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: ba-ui-common (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import React, { Component } from 'react';
import './LoadingDots.scss';

export default class LoadingDots extends Component<any, any> {
	render() {
		return (
			<svg
				className="bi-common-loading-dots"
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 16 16"
				id="loading-dots_16"
			>
				<circle className="bi-common-loading-dot" cx="2" cy="8" r="2" />
				<circle className="bi-common-loading-dot" cx="8" cy="8" r="2" />
				<circle className="bi-common-loading-dot" cx="14" cy="8" r="2" />
			</svg>
		);
	}
}
